// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifospay.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.setBody
import io.ktor.http.HttpMethod
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Long
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlinx.coroutines.flow.Flow
import org.mifospay.core.model.beneficiary.Beneficiary
import org.mifospay.core.model.beneficiary.BeneficiaryPayload
import org.mifospay.core.model.beneficiary.BeneficiaryUpdatePayload
import org.mifospay.core.network.model.entity.templates.beneficiary.BeneficiaryTemplate

@OptIn(InternalKtorfitApi::class)
public class _BeneficiaryServiceImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : BeneficiaryService {
  override fun beneficiaryList(): Flow<List<Beneficiary>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "beneficiaries/tpt")
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<List<Beneficiary>>>(),)!! 
  }

  override suspend fun beneficiaryTemplate(): Flow<BeneficiaryTemplate> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "beneficiaries/tpt/template")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<BeneficiaryTemplate>>(),)!! 
  }

  override suspend fun createBeneficiary(beneficiaryPayload: BeneficiaryPayload) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "beneficiaries/tpt")
        }
        setBody(beneficiaryPayload) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }

  override suspend fun updateBeneficiary(beneficiaryId: Long, payload: BeneficiaryUpdatePayload) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("PUT")
        url{
        takeFrom(_baseUrl + "beneficiaries/tpt/${"$beneficiaryId".encodeURLPath()}")
        }
        setBody(payload) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }

  override suspend fun deleteBeneficiary(beneficiaryId: Long) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("DELETE")
        url{
        takeFrom(_baseUrl + "beneficiaries/tpt/${"$beneficiaryId".encodeURLPath()}")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }
}

public class _BeneficiaryServiceProvider : ClassProvider<BeneficiaryService> {
  override fun create(_ktorfit: Ktorfit): BeneficiaryService = _BeneficiaryServiceImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createBeneficiaryService(): BeneficiaryService = _BeneficiaryServiceImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
